/* eslint-disable max-len */
export const VERIFICATION_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED_VERIFIED',
  FAILED: 'FAILED',
  WRONG_CUSTOMER: 'WRONG_CUSTOMER',
}

export const VERIFICATION_PROVIDERS = {
  JUMIO: 'jumio',
  STRIPE: 'stripe'
}

export const TRANSACTION_STATUSES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
}

export const VERIFICATION_MESSAGES = {
  PENDING:
    'Your ID verification is currently being processed. We will notify you as soon as it is completed. Thank you for your patience.',
  APPROVED: 'Your ID verification is approved!',
  FAILED: 'Unfortunately your ID verification has failed. Please try again.',
  WRONG_CUSTOMER: 'The order does not belong to the customer.',
}

export const DELEGATION_ACCESS_ERROR = 'Delegation Access not found'
